// Chinese (Simplified) translation

const zh = {
  "hotel.booking.number": "编号",
  "hotel.booking.party": "预订人",
  "hotel.booking.contact": "联系方式",
  "hotel.booking.bill_to": "开票给",
  "hotel.booking.bill.all": "全部",
  "hotel.booking.bill.partial": "部分",
  "hotel.booking.booking_date": "预订日期",
  "hotel.booking.total_amount": "总金额",
  "hotel.booking.total_advances": "预付款总额",
  "hotel.booking.lines": "房间数",
  "hotel.booking.media": "渠道",
  "hotel.booking.meal_plan": "餐饮计划",
  "hotel.booking.space": "空间",
  "hotel.booking.price_list": "价格表",
  "hotel.booking.payment_term": "付款期限",
  "hotel.booking.rate_plan": "价格计划",
  "hotel.booking.pending_to_pay": "待付款",
  "hotel.booking.group": "团队",
  "hotel.booking.corporative": "企业",
  "hotel.booking.state": "状态",
  "hotel.booking.offer": "优惠",
  "hotel.booking.complimentary": "赠送",
  "hotel.booking.confirm": "确认",
  "hotel.booking.cancelled": "已取消",
  "hotel.booking.no_show": "未到店",
  "hotel.booking.block": "锁定",
  "hotel.booking.finished": "已完成",
  "hotel.booking": "预订",
  "hotel.booking.today": "今天",
  "hotel.booking.confirmed": "已确认",
  "hotel.booking.bill": "开票",
  "hotel.booking.channel": "渠道",
  "hotel.booking.ota_booking_code": "OTA 编码",
  "hotel.booking.agent": "代理",
  "hotel.booking.notes": "备注",
  "hotel.booking.advances_payments": "预付款 / 付款",
  "hotel.booking.invoices": "发票",
  "hotel.booking.notifications": "通知",
  "hotel.booking.pax": "人数",
  "hotel.booking.taxes_exception": "增值税豁免",
  "hotel.booking.holder": "预订人",
  "hotel.booking.holder_guest": "预订人 / 客人",
  "hotel.booking.guest": "客人",
  "hotel.booking.blocked": "已锁定",
  "hotel.folio": "账单",
  "hotel.booking.lead_origin": "来源",
  "hotel.folio.overbooking": "超额预订",
  "hotel.folio.accept": "接受",
  "hotel.booking.add_rooms": "添加房间",
  "hotel.booking.add_rooms.accept": "接受",
  "hotel.booking_statement": "预结账单",
  "hotel.booking.plan+rate": "计划 + 不含税价格",
  "hotel.booking.fees_taxes_not_included": "费用及税费不包含在内",
  "hotel.booking.msg_iva_foreign":
    "外国客人不含增值税，入住时需核验护照及移民卡。",
  "hotel.booking.msg_iva": "已包含 19% 增值税。",
  "hotel.booking.i_foreigner": "我是外国人",
  "hotel.booking.i_colombiano": "我是哥伦比亚人",
  "hotel.booking.add_rooms.selector.product": "房型",
  "hotel.booking.add_rooms.selector.unit_price_w_tax": "价格",
  "hotel.booking.add_rooms.selector.available": "可用",
  "hotel.booking.add_rooms.selector.adults": "成人",
  "hotel.booking.add_rooms.selector.children": "儿童",
  "hotel.booking.add_rooms.selector.room": "房间",
  "hotel.booking.add_rooms.selector.add": "添加",
  "hotel.booking.add_rooms.selector.sale_price_taxed": "售价",
  "hotel.booking.add_rooms.selector.discount": "折扣",
  "hotel.booking.add_rooms.nights_quantity": "晚数",
  "hotel.booking.add_payment": "预付款 / 支付",
  "hotel.booking.add_payment.amount": "金额",
  "hotel.booking.add_payment.voucher": "凭证",
  "hotel.booking.add_payment.statement": "支付方式",
  "hotel.booking.add_payment.pay": "支付",
  "hotel.booking.add_room.arrival_date": "到达",
  "hotel.booking.add_room.departure_date": "离开",
  "hotel.booking.add_room.nights_quantity": "晚数",
  "hotel.booking.add_rooms.selector.rooms": "房间",
  "hotel.chart.occupation_room": "客房入住情况",
  "hotel.chart.occupation_today": "今天",
  "hotel.chart.occupation_tomorrow": "明天",
  "hotel.chart.check_in_today": "今日入住",
  "hotel.chart.check_out_today": "今日退房",
  "hotel.chart.occupation_rate": "入住率",
  "hotel.chart.occupation_rate_today": "今天",
  "hotel.chart.occupation_rate_tomorrow": "明天",
  "hotel.booking.bill.party": "第三方",
  "hotel.booking.bill.kind": "类型",
  "hotel.booking.bill.bill": "开票",
  "hotel.booking.bill.add_guest": "添加客人",
  "hotel.booking.bill.add_vehicle_plate": "添加车牌",
  "hotel.booking.wiz_payment.voucher": "凭证",
  "hotel.booking.wiz_payment.statement": "支付方式",
  "hotel.booking.wiz_payment.amount": "金额",
  "hotel.booking.wiz_payment.notes": "备注",
  "booking.widget_side.today": "今天",
  "booking.widget_side.tomorrow": "明天",
  "booking.widget_side_status.revenue_today": "今日收入",
  "hotel.booking.wiz_payment.button_pay": "支付",
  "hotel.booking.undefined": "未定义",
  "hotel.booking.environment": "环境",
  "hotel.booking.update_taxes": "更新税费",
  "hotel.booking.update_taxes.start.accept": "接受",
  "hotel.booking.update_taxes.start.taxes": "税费",
  "hotel.booking.apply_taxes_exception": "增值税豁免",
  "hotel.booking.add_rooms.selector.accommodation": "住宿类型",
  "hotel.booking.add_rooms.selector.availability": "可用性",
  "hotel.booking.whitout.rooms": "所选日期没有可用的房间",
  "hotel.booking.kids.policy": "儿童政策",
};

export default zh;
